export const getBankStatementData = (bankName, jsonData) => {
  switch (bankName) {
    case "State Bank of India":
      return getSbiData(jsonData);
    case "ICICI Bank Ltd":
      return getIciciData(jsonData);
    case "PNB":
      return getPnbData(jsonData);
    case "Axis Bank":
      return getAxisData(jsonData);
    case "HDFC Bank":
      return getHdfcData(jsonData);
    default:
      return [];
  }
};

export const getSbiData = (jsonData) => {
  var exelDataRead = [];
  jsonData.forEach((tranxt) => {
    if (tranxt.__EMPTY_1 != "") {
      exelDataRead.push({
        transactionId: tranxt.__EMPTY,
        transactionDate: tranxt.__EMPTY,
        postedDate: tranxt.__EMPTY,
        chequeNo: "NA",
        refId: "",
        description: tranxt.__EMPTY_1,
        type: "CR",
        amount: tranxt.__EMPTY_5,
        balance: tranxt.__EMPTY_6,
      });
    }
  });
  return exelDataRead;
};

export const getPnbData = (jsonData) => {
  var exelDataRead = [];
  jsonData.forEach((tranxt) => {
    if (tranxt.__EMPTY_1 != "") {
      exelDataRead.push({
        transactionId: tranxt["Branch Details"],
        transactionDate: tranxt.__EMPTY,
        postedDate: tranxt.__EMPTY,
        chequeNo: "NA",
        refId: "",
        description: tranxt.__EMPTY_1,
        type: "CR",
        amount: tranxt.__EMPTY_3,
        balance: tranxt.__EMPTY_4,
      });
    }
  });
  return exelDataRead;
};

export const getAxisData = (jsonData) => {
  var exelDataRead = [];
  jsonData.forEach((tranxt) => {
    if (tranxt.__EMPTY_3 != "") {
      exelDataRead.push({
        transactionId: tranxt.__EMPTY_2,
        transactionDate: tranxt.__EMPTY,
        postedDate: tranxt.__EMPTY_1,
        chequeNo: "NA",
        refId: "",
        description: tranxt.__EMPTY_3,
        type: tranxt.__EMPTY_5,
        amount: tranxt.__EMPTY_4,
        balance: tranxt.__EMPTY_6,
      });
    }
  });
  return exelDataRead;
};

export const getIciciData = (jsonData) => {
  var exelDataRead = [];
  jsonData.forEach((tranxt) => {
    if (tranxt.__EMPTY_1 != "") {
      exelDataRead.push({
        transactionId: tranxt.__EMPTY,
        transactionDate: tranxt.__EMPTY,
        postedDate: tranxt.__EMPTY,
        chequeNo: "NA",
        refId: "",
        description: tranxt.__EMPTY_1,
        type: "CR",
        amount: tranxt.__EMPTY_5,
        balance: tranxt.__EMPTY_6,
      });
    }
  });
  return exelDataRead;
};

export const getHdfcData = (jsonData) => {
  var exelDataRead = [];
  jsonData.forEach((tranxt) => {
    if (tranxt.__EMPTY_1 != "") {
      exelDataRead.push({
        transactionId: tranxt.__EMPTY,
        transactionDate: tranxt.__EMPTY,
        postedDate: tranxt.__EMPTY,
        chequeNo: "NA",
        refId: "",
        description: tranxt.__EMPTY_1,
        type: "CR",
        amount: tranxt.__EMPTY_5,
        balance: tranxt.__EMPTY_6,
      });
    }
  });
  return exelDataRead;
};
